import React, { useState } from "react";
import styles from '../../views/ManagementPages.module.css';
import './Accounts.css';
import { setNestedField } from './RegistrationSlice';
import { useSelector, useDispatch } from 'react-redux';
import { Form, FloatingLabel } from "react-bootstrap";
import Select from 'react-select';
import { customStyles } from "./CustomStyles";

const EmergencyContact = ({errors, validated = false}) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.registration);
    const dropdowns = useSelector((state) => state.dropdowns);
    const [phoneNumbersOnlyError, setPhoneNumbersOnlyError] = useState(false);

    const [displayPhoneCountryCode, setDisplayPhoneCountryCode] = useState(() => {
        const countryCodeMatch = dropdowns.countries.find((code)=>code.phoneCountryCode === userData.emergencyContact.countryCode)
        if (countryCodeMatch && userData.emergencyContact.countryCode !== "") {
            return {value: countryCodeMatch.phoneCountryCode, label: `${countryCodeMatch.phoneCountryCode} (${countryCodeMatch.name})`}
        } else return {value:'', label: ''}
    });

    const [displayCountry, setDisplayCountry] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.emergencyContact.country);
        return selectedCountry ? { value: selectedCountry.code, label: selectedCountry.name } : { value: '', label: '' };
    });
    
    const [displayState, setDisplayState] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.emergencyContact.country);
        const selectedState = selectedCountry?.states.find(state => state.code === userData.emergencyContact.state);
        return selectedState ? { value: selectedState.code, label: selectedState.name } : { value: '', label: '' };
    });

    const handlePhoneCountryCode = (selected) => {
        dispatch(setNestedField({ parentKey: "emergencyContact", nestedKey: 'countryCode', value: selected.value }));
        setDisplayPhoneCountryCode(selected);
    };

    const handleCountry = (selected) => {
        dispatch(setNestedField({ parentKey: "emergencyContact", nestedKey: "country", value: selected.value }))
        dispatch(setNestedField({ parentKey: "emergencyContact", nestedKey: "state", value: "" }))
        setDisplayState({ value: '', label: '' })
        setDisplayCountry(selected);
    };

    const handleState = (selected) => {
        dispatch(setNestedField({ parentKey: "emergencyContact", nestedKey: "state", value: selected.value }))
        setDisplayState(selected);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        dispatch(setNestedField({ parentKey: "emergencyContact", nestedKey: id, value: value }));

    };
    return (
        <div className="create-account-inputs">
            
            <Form.Group controlId="fullNameEmergencyContact">
                <FloatingLabel label="Emergency Contact Full Name">
                    <Form.Control
                        value={userData.emergencyContact.fullName}
                        id="fullName"
                        className={`${styles.BorderedComponent}`}
                        onChange={handleChange}
                        placeholder="Emergency Contact Full Name"
                        style={{ width: "300px" }}
                        type="text"
                    />
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="relationEmergencyContact">
                <FloatingLabel label="Relationship">
                    <Form.Select
                        type="select"
                        value={userData.emergencyContact.relation}
                        className={`${styles.BorderedComponent}`}
                        id="relation"
                        onChange={handleChange}
                        placeholder="Relationship"
                        style={{ width: "300px" }}
                    >
                        <option value="">Select a Relationship</option>
                        {dropdowns.relationship.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="genderEmergencyContact">
                <FloatingLabel label="Gender">
                    <Form.Select
                        type="select"
                        value={userData.emergencyContact.gender}
                        className={`${styles.BorderedComponent}`}
                        id="gender"
                        onChange={handleChange}
                        placeholder="Gender"
                        style={{ width: "300px" }}
                    >
                        <option value="">Select a Gender</option>
                        {dropdowns.gender.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
            </Form.Group>
            <div style={{ display: "flex", width: "300px", justifyContent: "space-between" }}>
                <div style={{position: "relative", width: "125px"}}>
                    <span className={"floating-label"} style={{zIndex:"1"}}>Country Code</span>
                                            <Select
                            options={[...dropdowns.countries]
                                .sort((a, b) => {
                                    // If both countries have +1, sort by name
                                    if (a.phoneCountryCode === "+1" && b.phoneCountryCode === "+1") {
                                        // Prioritize United States specifically
                                        if (a.name === "United States") return -1;
                                        if (b.name === "United States") return 1;
                                        return a.name.localeCompare(b.name);
                                    }
                                    // Put +1 countries at the top
                                    if (a.phoneCountryCode === "+1") return -1;
                                    if (b.phoneCountryCode === "+1") return 1;
                                    // Then sort alphabetically by name
                                    return a.name.localeCompare(b.name);
                                })
                                .map((code) => ({
                                    label: `${code.phoneCountryCode} (${code.name})`,
                                    value: code.phoneCountryCode
                                }))}
                            styles={{
                                ...customStyles.popup,
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#B2C7CE' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: 'black',
                                    cursor: 'pointer',
                                    ':hover': {
                                        backgroundColor: state.isSelected ? '#B2C7CE' : '#f0f0f0',
                                    }
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    borderRadius: '6px',
                                    height: '44px',
                                    borderWidth: '0.5px',
                                    borderColor: (errors && userData.emergencyContact.phone !== '' && userData.emergencyContact.countryCode === '') ? '#dc3545' : '#686869',
                                }),
                            }}
                            value={displayPhoneCountryCode}
                            placeholder='Code*'
                            isSearchable={true}
                            onChange={handlePhoneCountryCode}
                            defaultValue={null}
                            menuPlacement="auto"
                        />
                        {errors && userData.emergencyContact.phone !== '' && userData.emergencyContact.countryCode === '' &&
                        <div className="page-error">
                            Please provide a valid country code.
                        </div>
                    }
                </div>
                <Form.Group controlId="phoneEmergencyContact">
                    <FloatingLabel label="Phone Number">
                        <Form.Control
                            id="phone"
                            value={userData.emergencyContact.phone}
                            className={`${styles.BorderedComponent}`}
                            onChange={(e) => {
                                const raw = e.target.value;
                                const digitsOnly = raw.replace(/\D/g, "").slice(0, 10);
                                setPhoneNumbersOnlyError(/[^\d]/.test(raw));
                                dispatch(setNestedField({ parentKey: "emergencyContact", nestedKey: "phone", value: digitsOnly }));
                            }}
                            placeholder="Phone Number*"
                            style={{
                                width: "170px",
                                paddingRight: "0px"
                            }}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]{10}"
                                isInvalid={
                                    phoneNumbersOnlyError ||
                                    (validated && !/^\d{10}$/.test(userData.emergencyContact.phone))
                                }
                        />
                        <Form.Control.Feedback style={{ width: "170px" }} type="invalid"> 
                            {phoneNumbersOnlyError
                                ? "numbers only"
                                : "Please provide a valid phone number; phone numbers must be 10 digits in length."}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </div>

            <Form.Group controlId="emailEmergencyContact">
                <FloatingLabel label="Email">
                    <Form.Control
                        value={userData.emergencyContact.email}
                        className={`${styles.BorderedComponent}`}
                        onChange={handleChange}
                        placeholder="Email"
                        style={{ width: "300px" }}
                        type="email"
                        id="email"
                        isInvalid={errors && userData.emergencyContact.phone === '' && userData.emergencyContact.email === ''}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors && userData.emergencyContact.phone === '' && userData.emergencyContact.email === '' ? "Please provide either a phone number or email address." : "Please provide a valid email address."}
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>

            <Form.Group controlId="address1EmergencyContact">
                <FloatingLabel label="Street Address (Ave, St, Blvd, etc.)">
                    <Form.Control
                        value={userData.emergencyContact.address1}
                        id="address1"
                        className={`${styles.BorderedComponent}`}
                        onChange={handleChange}
                        placeholder="Street Address (Ave, St, Blvd, etc.)"
                        style={{ width: "300px" }}
                        type="text"
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group controlId="address2EmergencyContact">
                <FloatingLabel label="Apartment, Suite, etc">
                    <Form.Control
                        value={userData.emergencyContact.address2}
                        id="address2"
                        className={`${styles.BorderedComponent}`}
                        onChange={handleChange}
                        placeholder="Apartment, Suite, etc"
                        style={{ width: "300px" }}
                        type="text"
                    />
                </FloatingLabel>
            </Form.Group>
            <div style={{ display: "flex", flexDirection: "column", width: "300px" }}>
                <div className="input-block">
                    <div style={{position: "relative", width: "147px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>Country</span>
                        <Select
                            options={[...dropdowns.countries]
                                .sort((a, b) => {
                                    // Prioritize United States
                                    if (a.name === "United States") return -1;
                                    if (b.name === "United States") return 1;
                                    // Then sort alphabetically by name
                                    return a.name.localeCompare(b.name);
                                })
                                .map((country) => ({
                                    label: country.name,
                                    value: country.code
                                }))}
                            styles={{
                                ...customStyles.popup,
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#B2C7CE' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: 'black',
                                    cursor: 'pointer',
                                    ':hover': {
                                        backgroundColor: state.isSelected ? '#B2C7CE' : '#f0f0f0',
                                    }
                                }),
                            }}
                            value={displayCountry}
                            placeholder='Country'
                            isSearchable={true}
                            onChange={handleCountry}
                            defaultValue={null}
                            menuPlacement="auto"
                        />
                    </div>
                    <div style={{position: "relative", width: "147px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>State</span>
                            <Select
                                options={
                                    displayCountry.value
                                        ? dropdowns.countries
                                              .find(country => country.code === displayCountry.value)
                                              ?.states.map(state => ({
                                                  label: state.name,
                                                  value: state.code
                                              })) || []
                                        : []
                                }
                                styles={{
                                    ...customStyles.popup,
                                    container: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                    }),
                                }}
                                value={displayState}
                                placeholder='State'
                                isSearchable={true}
                                onChange={handleState}
                            />
                    </div>
                </div>
                <div className="input-block" style={{ marginBottom: "0px" }}>
                    <Form.Group controlId="cityEmergencyContact">
                        <FloatingLabel label="City">
                            <Form.Control
                                value={userData.emergencyContact.city}
                                id="city"
                                className={`${styles.BorderedComponent}`}
                                onChange={handleChange}
                                placeholder="City"
                                style={{ width: "147px" }}
                                type="text"
                            />

                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group controlId="zipEmergencyContact">
                        <FloatingLabel label="Postal Code">
                            <Form.Control
                                value={userData.emergencyContact.zip}
                                id="zip"
                                className={`${styles.BorderedComponent}`}
                                onChange={handleChange}
                                placeholder="Postal Code"
                                style={{ width: "147px" }}
                                type="text"
                                pattern="^\d{5}$"
                                isInvalid={
                                    validated && !/^\d{5}$/.test(userData.emergencyContact.zip)
                                }
                            />
                            <Form.Control.Feedback style={{ width: "147px" }} type="invalid">
                            Please provide a valid postal code; postal codes must contain only numbers and be 5 digits in length.
                        </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </div>
            </div>
        </div>
    );
};


export default EmergencyContact; 